import i18n from "components/i18n/i18n";

export class I18nMessage {
    public level: "error" | "warning" | "info" | "success";;
    public key: string;
    public args: object;

    constructor(definition: I18nMessageDefinition|string) {
        if (isI18nMessageDefinition(definition)) {
            this.level = definition.level;
            this.key = definition.key;
            this.args = definition.args;
        } else {
            this.key = definition;
        }
    }

    public toFlatObject() {
        if (this.level == null && this.args == null) {
            return this.key;
        }
        let message = Object.assign(
            { key: this.key },
            this.args,
        );
        return message;
    }

    public toString(): string {
        return i18n.instance.t(this.key, this.args);
    }
}

export function isI18nMessageDefinition(arg: any): arg is I18nMessageDefinition {
    return arg != null && arg.key !== undefined;
}


export interface I18nMessageDefinition {
    level?: "error" | "warning" | "info" | "success";
    key: string;
    args?: object;
}
